import { stripJoinPath }  from '../../../helpers/joinPath';

export const joinPath = stripJoinPath;
export const formatEditLink = (contentId, locale) => `/en-us/cms/contents/edit/${ contentId }/${ locale.toLowerCase() }`;
export const formatViewDraftLink = (contentId, locale) => `/en-us/cms/contents/preview/${ contentId }/${ locale.toLowerCase() }`;
export const formatViewPublishedLink = (content, locale) => `/${joinPath(locale.toLowerCase(), content.path, content.slug)}`;

